import { render, staticRenderFns } from "./claim-vpbox-view.vue?vue&type=template&id=1e171495&"
import script from "./claim-vpbox-view.vue?vue&type=script&lang=ts&"
export * from "./claim-vpbox-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports